export default function Home() {
    return (
        <div className="home">
            <h1>Шахматный турнир</h1>
            <img src="https://i.imgur.com/it6eC7y.jpg" alt="chess" />

        </div>
    );
}